module.exports = __webpack_public_path__ + "static/media/xamarin.dff16d10.png";